import { Route, Routes, Navigate } from 'react-router-dom'
import * as Sentry from '@sentry/react'

import { InvalidLink } from '../app/InvalidLink/InvalidLink'
import { EducationHostedFormContainer } from '../app/EducationHostedForm/EducationHostedFormContainer'

import { AppRoute } from './AppRoute.enum'
import { GOODSTACK_EDU_HELP_CENTER_URL } from '@percent/education-hosted-form/constants'

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes)

export function AppRoutes() {
  return (
    <SentryRoutes>
      <Route path={AppRoute.FORM_PAGE} element={<EducationHostedFormContainer />} />
      <Route
        path={AppRoute.LINK_USED}
        element={
          <InvalidLink
            screen={AppRoute.LINK_USED}
            title="typography.linkAlreadyUsedTitle"
            description="typography.linkAlreadyUsedDescription"
          />
        }
      />
      <Route
        path={AppRoute.NOT_FOUND}
        element={
          <InvalidLink
            screen={AppRoute.NOT_FOUND}
            title="typography.invalidLinkTitle"
            description="typography.invalidLinkDescription"
          />
        }
      />
      <Route
        path={AppRoute.EXPIRED}
        element={
          <InvalidLink
            screen={AppRoute.EXPIRED}
            title="typography.expiredLinkTitle"
            description="typography.expiredLinkDescription"
            helpCenterUrl={GOODSTACK_EDU_HELP_CENTER_URL}
          />
        }
      />
      <Route path="*" element={<Navigate to={AppRoute.NOT_FOUND} replace />} />
    </SentryRoutes>
  )
}
